import React, { Component } from 'react';
import {
  bool, func, oneOf, shape, string
} from 'prop-types';
import { connect } from 'react-redux';
import BackButton from '../BackButton';
import { endSurvey, getSurveyInfo, getSurveySchedule } from '../../api';
import {
  addErrorMessageAction, updateSurveyMessageAction, setTaskPending,
  setTaskFulfilled, clearSurveyAction
} from '../../actions';
import StatisticsInfoBox from '../SurveyStatistics/StatisticsInfoBox';
import EmailMessageInput from '../EmailMessageInput';
import { routes, surveyFieldIds } from '../../constants';
import WithValidation from '../WithValidation';
import { closeSurveyPageValidator } from '../../validators/surveys';
import { surveyOptionsType, surveyTypeValues } from '../../constants/types';
import sharedStyles from '../../styles/shared';
import withRouter from '../WithRouter';
import { withLang, langType } from '../../i18n';
import { getSubRouteForSurveyType, setDocumentTitle } from '../../util';

class CloseSurveyView extends Component {
  constructor(props) {
    super(props);
    this.state = { surveyInfo: null, surveySchedule: null };
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    const { surveyId } = this.props.params;

    this.props.dispatchSetTaskPending();
    Promise.all([getSurveyInfo(surveyId), getSurveySchedule(surveyId)])
      .then(([surveyInfo, surveySchedule]) => {
        this.setState({ surveyInfo, surveySchedule });
      })
      .catch(this.props.dispatchAddErrorMessage)
      .finally(this.props.dispatchSetTaskFulfilled);
  }

  componentWillUnmount() {
    this.props.dispatchClear();
  }

  closeCourseSurvey() {
    endSurvey(this.state.surveyInfo.id)
      .then(() => this.props.navigate(routes.surveys.husSurveys.index));
  }

  closeSurvey() {
    const { surveyId } = this.props.params;
    const data = {
      endingEmailTitle: this.props.surveyOptions.endingEmailTitle,
      endingEmailContent: this.props.surveyOptions.endingEmailContent
    };

    this.props.dispatchUpdateSurveyMessage(surveyId, data)
      .then(() => endSurvey(this.state.surveyInfo.id))
      .then(() => this.props.navigate(this.props.navigate(getSubRouteForSurveyType(this.props.type).index)))
      .catch((err) => {
        this.props.dispatchAddErrorMessage(err);
      });
  }

  close(event) {
    event.preventDefault();
    if (this.props.type === surveyTypeValues.COURSE_SURVEY) {
      this.closeCourseSurvey();
    } else {
      this.closeSurvey();
    }
  }

  render() {
    const { type, translate: t } = this.props;
    setDocumentTitle(t('manageSurveys.closeSurvey'));
    return (
      <div className="page-container">
        <h2>{t('manageSurveys.closeSurvey')}</h2>
        <BackButton />
        {(this.state.surveyInfo && this.state.surveySchedule)
          && (
          <StatisticsInfoBox
            surveyInfo={this.state.surveyInfo}
            surveySchedule={this.state.surveySchedule}
          />
          )}
        <form>
          {type !== surveyTypeValues.COURSE_SURVEY
            ? (
              <div>
                <h2 className="panel__title">{t('startSurvey.email.endingTitle')}</h2>
                <EmailMessageInput
                  messageTitleName={surveyFieldIds.ENDING_TITLE}
                  messageContentName={surveyFieldIds.ENDING_CONTENT}
                  hasInvalidField={this.props.hasInvalidField}
                  dataCyPrefix="survey-ending-email"
                />
              </div>
            ) : null }

          <button
            type="submit"
            disabled={!this.props.isValid}
            className={`${sharedStyles.submitButton} button`}
            onClick={this.close}
            data-cy="confirm-close-survey-button"
          >{type !== surveyTypeValues.COURSE_SURVEY
            ? t('common.submit')
            : t('manageSurveys.confirmCloseSurvey')}
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ survey }) => ({
  surveyOptions: survey.surveyOptions
});

const mapDispatchToProps = (dispatch) => ({
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
  dispatchUpdateSurveyMessage: (id, data) => dispatch(updateSurveyMessageAction(id, data)),
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled()),
  dispatchClear: () => dispatch(clearSurveyAction())
});

CloseSurveyView.propTypes = {
  dispatchAddErrorMessage: func.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired,
  dispatchClear: func.isRequired,
  isValid: bool.isRequired,
  hasInvalidField: func.isRequired,
  dispatchUpdateSurveyMessage: func.isRequired,
  params: shape({
    surveyId: string
  }).isRequired,
  navigate: func.isRequired,
  surveyOptions: surveyOptionsType.isRequired,
  type: oneOf(Object.values(surveyTypeValues)).isRequired,
  translate: langType.translate.isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  withLang(WithValidation(CloseSurveyView, closeSurveyPageValidator))
));
